<!-- prettier-ignore -->
<template>
    <span v-if="contactType === CONTACT_TRYOUT">
        Whatsapp <a href="https://wa.me/+6281287180586" target="_blank">+6281-2871-8058-6</a>,
        Instagram <a href="https://www.instagram.com/ukomnakes.id/">@ukomnakes.id</a>,
    </span>

    <span v-else>
        Line <a href="http://line.me/ti/p/~@mediko.belajarfk">@mediko.belajarfk</a> atau WA <a href="https://wa.me/6281259119472" target="_blank">081259119472</a><br />
    </span>
</template>

<script>
import { get } from 'vuex-pathify'

export default {
    data() {
        return {
            CONTACT_TRYOUT: 1,
        }
    },

    computed: {
        contactType: get('enrollment/selected@contact_type'),
    },
}
</script>
